import BeatLoader from 'react-spinners/BeatLoader';

const Loader = () => {
  return <BeatLoader size={10} color="red" />;
};

export default Loader;
